import { useCallback, useRef, useState } from "react";
import { fetchStores } from "../redux/action/stores";

// Re-reads GET /v1/stores when a store dropdown is opened, so a store added or
// renamed elsewhere appears without a reload. The list is persisted, so without
// this it stays as it was at sign-in.
//
// Opens that overlap share one request: a double click on the dropdown, or two
// dropdowns opening together, should not mean two calls.
export const useStoreListRefresh = () => {
  const [refreshing, setRefreshing] = useState(false);
  const inFlight = useRef(null);

  const refresh = useCallback(() => {
    if (!inFlight.current) {
      setRefreshing(true);
      inFlight.current = fetchStores().finally(() => {
        inFlight.current = null;
        setRefreshing(false);
      });
    }

    return inFlight.current;
  }, []);

  return { refreshing, refresh };
};
